import Widget from './Widget';
import { DRAG_HANDLE_ELEMENT } from './constants';

export default Widget;
export { DRAG_HANDLE_ELEMENT };
